<template>
  <el-form :model="form" label-width="160px">
    <el-form-item label="Date du ramassage">
      <el-date-picker v-model="pickupDate" type="date" />
    </el-form-item>

    <el-form-item label="Heure prête à partir de">
      <el-time-picker v-model="readyAtPickupTime" format="HH:mm" />
    </el-form-item>

    <el-form-item label="Heure limite de ramassage">
      <el-time-picker v-model="readyUntilPickupTime" format="HH:mm" />
    </el-form-item>

    <el-form-item
      :label="'Poids total ('+packageDetails.weight.unit+')'"
    >
      <el-input
        v-model.number="form.pickup_details.package_details.weight.value"
      />
    </el-form-item>

    <el-form-item label="Nombre de colis">
      <el-input v-model.number="form.pickup_details.package_details.quantity" />
    </el-form-item>

    <el-form-item label="Lieu de ramassage">
      <el-select
        v-model="form.pickup_details.pickup_location"
        placeholder="Sélectionner"
      >
        <el-option
          v-for="loc in pickupLocations"
          :key="loc"
          :label="$t('ELIXIO_CONNECT.' + loc)"
          :value="loc"
        />
      </el-select>
      <!-- <el-select v-model="form.pickup_details.pickup_location" placeholder="Sélectionner">
        <el-option
          v-for="loc in pickupLocations"
          :key="loc.value"
          :label="loc.label"
          :value="loc.value"
        />
      </el-select> -->
    </el-form-item>

    <el-form-item label="Instructions">
      <el-input
        v-model="form.pickup_details.pickup_instructions"
        type="textarea"
      />
    </el-form-item>

    <div class="flex gap-2">
      <el-button type="primary" :disabled="loading" @click="submitPickup"
        >Créer le pickup</el-button
      >
      <el-button @click="$emit('cancel')">Annuler</el-button>
    </div>
  </el-form>
</template>

<script>
import {
  PICKUP_LOCATIONS,
  DEFAULT_PICKUP_LOCATION,
} from "@/components/ElixioConnect/constants/shipment";

import { DatePicker, TimePicker } from "element-ui";
import { Form, FormItem, Card, Button, Select, Option, Divider } from "element-ui";

export default {
  name: "pickup-form",
  components: {
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Card.name]: Card,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Divider.name]: Divider,
  },
  props: {
    groupId: { type: String, required: true },
    initialDetails: { type: Object, required: true },
  },
  data() {
    return {
      defaultPickupLocation: DEFAULT_PICKUP_LOCATION,
      form: JSON.parse(JSON.stringify(this.initialDetails)),
      pickupLocations: PICKUP_LOCATIONS,
      loading: false,
      packageDetails: {
        weight : {
            unit: 'kg',
            value: '1',
        },
        packages:[
          {
              depth: '1',
              width: '13',
              length: '20',
              weight: '1',
              quantity: '1',
          }
        ]
      }
    };
  },
  created(){
    console.log('initialDetails',this.initialDetails);
    this.form = _.merge({}, this.form, this.initialDetails);
  },
  computed: {
    pickupDate: {
      get() {
        if (!this.form.pickup_details) return;
        const d = this.form?.pickup_details?.date;
        return new Date(d.year, d.month - 1, d.day);
      },
      set(val) {
        if (!this.form.pickup_details) return;
        this.form.pickup_details.date = {
          year: val.getFullYear(),
          month: val.getMonth() + 1,
          day: val.getDate(),
        };
      },
    },
    readyAtPickupTime: {
      get() {
        
        const t = this.form?.pickup_details?.ready_at;
        if (!t || typeof t.hour !== "number" || typeof t.minute !== "number") {
          return null;
        }
        return new Date(0, 0, 0, t.hour, t.minute);
      },
      set(val) {
        if (!this.form.pickup_details) return;
        if (val instanceof Date) {
          this.form.pickup_details.ready_at = {
            hour: val.getHours(),
            minute: val.getMinutes(),
          };
        } else {
          this.form.pickup_details.ready_at = { hour: 0, minute: 0 };
        }
      },
    },
    readyUntilPickupTime: {
      get() {
        const t = this.form?.pickup_details?.ready_until;
        if (!t || typeof t.hour !== "number" || typeof t.minute !== "number") {
          return null;
        }
        return new Date(0, 0, 0, t.hour, t.minute);
      },
      set(val) {
        if (!this.form.pickup_details) return;
        if (val instanceof Date) {
          this.form.pickup_details.ready_until = {
            hour: val.getHours(),
            minute: val.getMinutes(),
          };
        } else {
          this.form.pickup_details.ready_until = { hour: 0, minute: 0 };
        }
      },
    },
  },
  methods: {
    async submitPickup() {
      this.loading = true;
      // convertir en string AVANT l’envoi
      this.form.pickup_details.package_details.weight.value =
        String(this.form.pickup_details.package_details.weight.value);

      this.form.pickup_details.package_details.quantity =
        String(this.form.pickup_details.package_details.quantity);
        if(!this.form.pickup_details.pickup_location){
          this.loading = false;
          this.$notify({
            type: "danger",
            message: this.  $t("ERRORS.LOCATION_REQUIRED"),
          });
          return;
        }
      try {
            const response = await this.$store.dispatch("properties/createPickup", {form_data : this.form, group_id: this.groupId});
            this.$notify({
                type: "success",
                message: this.$t("SHIPMENTS.PICKUP_TO_CREATE"),
            });
            this.loading = false;
            this.$emit("pickupCreated");
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
